import React, { Component } from 'react';
import { Button, translate } from 'react-admin';
import QrcodeIcon from '../../icon/IcnQrcode';

class QrcodeButton extends Component {

    handleClick = () => {
        const { record } = this.props;
        const { translate } = this.props;

        var options = {
            method: 'GET',
            credentials: 'include',
            mode: 'cors'
        }
        var request = new Request(process.env.REACT_APP_RSB_API_ENDPOINT + '/qrcodes/' + record.id);

        var qrWindow = this.openQrcodeWindow(record.name, translate('resources.qrcodes.fields.message'));

        fetch(request, options)
            .then(response => response.blob())
            .then(blob => this.loadImage(blob, qrWindow));
    }

    openQrcodeWindow(name, message) {
        var qrWindow = window.open('');
        qrWindow.document.open();
        qrWindow.document.write('<HTML><HEAD>');
        qrWindow.document.write('<TITLE>' + name + '</TITLE>');
        qrWindow.document.write('<BODY><div align="center">');
        qrWindow.document.write('<img src="" id="qrcode">');
        qrWindow.document.write('<br>' + name);
        qrWindow.document.write('<br><br><br>' + message);
        qrWindow.document.write('</div></BODY></HTML>');
        qrWindow.document.close();
        return qrWindow;
    }

    loadImage(blob, qrWindow) {
        var reader = new FileReader();
        reader.onloadend = function () {
            var img = qrWindow.document.getElementById("qrcode");
            img.src = reader.result;
        }
        reader.readAsDataURL(blob);
    }

    render() {
        return <Button
            label='resources.qrcodes.name'
            onClick={this.handleClick}
        >
            <QrcodeIcon />
        </Button>;
    }
};

export default translate(QrcodeButton);